import { EquipmentGroup } from '~/db_types/swagger_types';
export const EquipmentGroupNumberOnlyDisplay = new Map([
    [EquipmentGroup.CREW_ESCAPE_SYSTEM, '02.15'],
    [EquipmentGroup.CTSD, '12.00'],
    [EquipmentGroup.ELECTRICAL, 'Electrical'],
    [EquipmentGroup.ER, 'ER'],
    [EquipmentGroup.EVA_SUPPORT_EQUIPMENT, '02.06'],
    [EquipmentGroup.FOOD_AND_MEDICAL_SYSTEMS, '02.04'],
    [EquipmentGroup.GENERAL, 'General'],
    [EquipmentGroup.GRAIL, 'Grail'],
    [EquipmentGroup.MECHANICAL, 'Mechanical'],
    [EquipmentGroup.NON_FCE, '02.00'],
    [EquipmentGroup.OBS, '02.03'],
    [EquipmentGroup.PGSC_PCS, '02.19'],
    [EquipmentGroup.PHOTOGRAPHIC_EQUIPMENT, '02.10'],
    [EquipmentGroup.SHARED_CONSUMABLES, '09.00'],
    [EquipmentGroup.XEMU, '11.00'],
    [EquipmentGroup.XINFO, '11.01'],
    [EquipmentGroup.XPGS, '11.02'],
    [EquipmentGroup.XPLSS, '11.03']
]);
export const EquipmentGroupWordOnlyDisplay = new Map([
    [EquipmentGroup.CREW_ESCAPE_SYSTEM, 'Crew Escape System'],
    [EquipmentGroup.CTSD, 'CTSD'],
    [EquipmentGroup.ELECTRICAL, 'Electrical'],
    [EquipmentGroup.ER, 'ER'],
    [EquipmentGroup.EVA_SUPPORT_EQUIPMENT, 'EVA Support Equipment'],
    [EquipmentGroup.FOOD_AND_MEDICAL_SYSTEMS, 'Food & Medical Systems'],
    [EquipmentGroup.GENERAL, 'General'],
    [EquipmentGroup.GRAIL, 'Grail'],
    [EquipmentGroup.MECHANICAL, 'Mechanical'],
    [EquipmentGroup.NON_FCE, 'Non-FCE'],
    [EquipmentGroup.OBS, 'OBS'],
    [EquipmentGroup.PGSC_PCS, 'PGSC / PCS'],
    [EquipmentGroup.PHOTOGRAPHIC_EQUIPMENT, 'Photographic Equipment'],
    [EquipmentGroup.SHARED_CONSUMABLES, 'Shared consumables'],
    [EquipmentGroup.XEMU, 'xEMU'],
    [EquipmentGroup.XINFO, `xInfo`],
    [EquipmentGroup.XPGS, 'xPGS'],
    [EquipmentGroup.XPLSS, 'xPLSS']
]);
export const EquipmentGroupDisplay = new Map([
    [EquipmentGroup.CREW_ESCAPE_SYSTEM, '02.15 - Crew Escape System'],
    [EquipmentGroup.CTSD, '12.00 - CTSD'],
    [EquipmentGroup.ELECTRICAL, 'Electrical'],
    [EquipmentGroup.ER, 'ER'],
    [EquipmentGroup.EVA_SUPPORT_EQUIPMENT, '02.06 - EVA Support Equipment'],
    [EquipmentGroup.FOOD_AND_MEDICAL_SYSTEMS, '02.04 - Food & Medical Systems'],
    [EquipmentGroup.GENERAL, 'General'],
    [EquipmentGroup.GRAIL, 'Grail'],
    [EquipmentGroup.MECHANICAL, 'Mechanical'],
    [EquipmentGroup.NON_FCE, '02.00 - Non-FCE'],
    [EquipmentGroup.OBS, '02.03 - OBS'],
    [EquipmentGroup.PGSC_PCS, '02.19 - PGSC/PCS'],
    [EquipmentGroup.PHOTOGRAPHIC_EQUIPMENT, '02.10 - Photographic Equipment'],
    [EquipmentGroup.SHARED_CONSUMABLES, '09.00 - Shared consumables'],
    [EquipmentGroup.XEMU, '11.00 - xEMU'],
    [EquipmentGroup.XINFO, `11.01 - xInfo`],
    [EquipmentGroup.XPGS, '11.02 - xPGS'],
    [EquipmentGroup.XPLSS, '11.03 - xPLSS']
]);
